module.exports = __webpack_public_path__ + "img/podcast-singular.0a416781.jpg";